var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEdit(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.3749 13.5519C20.7528 13.5519 20.25 14.056 20.25 14.6769V23.6769C20.25 24.2968 19.7459 24.8019 19.1251 24.8019H3.375C2.75393 24.8019 2.25007 24.2968 2.25007 23.6769V7.92688C2.25007 7.30704 2.75393 6.80195 3.375 6.80195H12.3751C12.9972 6.80195 13.5 6.29788 13.5 5.67702C13.5 5.05595 12.9972 4.55188 12.3751 4.55188H3.375C1.51426 4.55188 0 6.06614 0 7.92688V23.6769C0 25.5377 1.51426 27.0519 3.375 27.0519H19.1251C20.9858 27.0519 22.5001 25.5377 22.5001 23.6769V14.6769C22.5001 14.0548 21.997 13.5519 21.3749 13.5519Z",
    fill: "#FF0000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5478 12.5271C10.4691 12.6058 10.4161 12.7059 10.3937 12.8138L9.59835 16.792C9.56127 16.9763 9.61978 17.1665 9.75244 17.3004C9.85935 17.4073 10.0033 17.4646 10.1508 17.4646C10.1867 17.4646 10.224 17.4613 10.261 17.4534L14.2379 16.6581C14.3482 16.6354 14.4483 16.5827 14.5259 16.5038L23.4269 7.60281L19.45 3.6261L10.5478 12.5271Z",
    fill: "#FF0000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.1764 0.875544C25.0797 -0.221373 23.2954 -0.221373 22.1995 0.875544L20.6426 2.43244L24.6195 6.40936L26.1764 4.85225C26.7074 4.32244 27 3.61588 27 2.86441C27 2.11295 26.7074 1.40639 26.1764 0.875544Z",
    fill: "#FF0000"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.245a2bcd.svg";
export { ForwardRef as ReactComponent };